import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

const icons: Record<string, string> = {
  news: "ri-megaphone-line",
  lifestyle: "ri-leaf-line",
  trend: "ri-line-chart-line",
};

export default function CategoryEntries() {
  return (
    <section className="bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mb-10 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-accent-600">Explore</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            三大内容频道
          </h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          品牌动态、生活方式与潮流趋势，从不同维度带你读懂台北娜娜的世界。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {categories.map((category) => (
          <Link
            key={category.key}
            to={`/${category.key}`}
            className="group relative cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-100"
          >
            <div className="aspect-[16/10] w-full overflow-hidden">
              <img
                src={category.cover}
                alt={category.name}
                title={`${category.name} - 台北娜娜`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className={`${icons[category.key]} text-xl`} />
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{category.intro}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-accent-600 transition-all group-hover:gap-3">
                进入频道
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}